import React, { useState } from 'react';
import zoneAlerts from '../defaults/ZoneAlerts'
import CustomSwitch from './CustomSwitch'
import { FormControlLabel } from '@material-ui/core';
const NotificationSwitches = (props) => {
  const { notifications, setNotifications } = props
  let [notificationsKey, setNotificationsKey] = useState(Math.random(4))
  let [allAlerts, changeAllAlerts] = useState(null)


  let divs = []

  const allAlertsSwitch = <CustomSwitch key={notificationsKey} checked={notifications.enabled_all_notifications} onChange={(e) => {
    let updateNotifications = notifications
    updateNotifications.enabled_all_notifications = !updateNotifications.enabled_all_notifications
    setNotifications(updateNotifications)
    setNotificationsKey(Math.random(4))
    changeAllAlerts(!allAlerts)
  }} />


  if (allAlerts === null) changeAllAlerts(props.record.enabled_all_notifications)
  for (let alert of [...zoneAlerts]) {
    const source = alert.column
    const hasNotBeenSet = notifications[source] === null
    const existingData = hasNotBeenSet && props.record[source]

    const alertSwitch = <FormControlLabel
      key={source}
      label={alert.name}
      control={
        <CustomSwitch
          checked={notifications[source]}
          onChange={() => handleSwitch(source)}
        />}
    />

    if (existingData) {
      notifications[source] = props.record[source]
    } else if (hasNotBeenSet) {
      notifications[source] = false
    }

    if (alert.column !== 'enabled_all_notifications') {
      divs.push(alertSwitch)
    }
  }

  const handleSwitch = (source) => {
    let updateNotifications = notifications
    updateNotifications[source] = !updateNotifications[source]
    const enabledTAS = updateNotifications.enabled_tas_notifications
    if (source === 'enabled_tas_notifications') {
      updateNotifications.enabled_falsealert_notifications = true
    }
    if (source === 'enabled_falsealert_notifications' && enabledTAS) {
      updateNotifications.enabled_falsealert_notifications = true
    }

    setNotifications(updateNotifications)
    setNotificationsKey(Math.random(4))
  }
  return (
    <div >
      <FormControlLabel
        control={allAlertsSwitch}
        label={"All Alerts"}
      />
      {!allAlerts &&
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          {divs}
        </div>}
    </div>
  )
}

export default NotificationSwitches